import axios from './request';
import globalServices from './platformApi';
const PlatformApi = {};
const urlsAllThere = {};
PlatformApi.getUrl = (key) => urlsAllThere[key].url;
export const generator = (urls) => {
  const mergedUrls = {
    ...globalServices,
    ...urls,
  };
  const handleUrl = (key) => {
    const {
      method, url, responseType
    } = mergedUrls[key];
    return {
      method,
      url,
      responseType,
    };
  };
  Object.keys(mergedUrls).forEach((item) => {
    urlsAllThere[item] = mergedUrls[item];
    const localItem = handleUrl(item);
    const { method } = localItem;
    switch (String(method).toUpperCase()) {
      case 'POST':
      case 'PUT':
      case 'PATCH':
        PlatformApi[item] = (params) => axios(Object.assign({}, localItem, {
          data: params,
        }));
        break;
      default:
        PlatformApi[item] = (params) => axios(Object.assign({}, localItem, {
          params,
        }));
    }
  });
  return PlatformApi;
};
generator(globalServices);
export default PlatformApi;



// WEBPACK FOOTER //
// ./src/services/platform-user/index.js